import React, { createContext, useContext } from 'react';
import { useNotifications } from '../hooks/useNotifications';
import Notifications from '../components/Notifications';

interface NotificationsContextType {
  notifications: any[];
  showSuccess: (title: string, message?: string, duration?: number) => string;
  showError: (title: string, message?: string, duration?: number) => string;
  showInfo: (title: string, message?: string, duration?: number) => string;
  showWarning: (title: string, message?: string, duration?: number) => string;
  showLoading: (title: string, message?: string) => string;
  removeNotification: (id: string) => void;
  updateNotification: (id: string, updates: any) => void;
}

const NotificationsContext = createContext<NotificationsContextType | undefined>(undefined);

export const useNotificationsContext = () => {
  const context = useContext(NotificationsContext);
  if (!context) {
    throw new Error('useNotificationsContext must be used within a NotificationsProvider');
  }
  return context;
};

export const NotificationsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const {
    notifications,
    showSuccess,
    showError,
    showInfo,
    showWarning,
    showLoading,
    removeNotification,
    updateNotification,
  } = useNotifications();

  return (
    <NotificationsContext.Provider
      value={{
        notifications,
        showSuccess,
        showError,
        showInfo,
        showWarning,
        showLoading,
        removeNotification,
        updateNotification,
      }}
    >
      {children}
      <Notifications notifications={notifications} onRemove={removeNotification} />
    </NotificationsContext.Provider>
  );
};